export const MODAL_TITLE = 'Depreciation';
